import { useFormContext } from 'react-hook-form';
import type { FormSchemaType } from '../../schema';

export const useDevisFormatedData = () => {
    const methods = useFormContext<FormSchemaType>();

    const Devis = methods.watch('Devis');


    const DevisVehicules = Devis.ListeVehicules ?? Devis.ListeVehicules;
    const Formules = DevisVehicules[0].ListeFormules; // for label, ....
    const Options = Formules[0].ListeGaranties.filter((garantie) => garantie.TypeGarantie === 'Option').sort((a, b) => a.OrdreAffichage - b.OrdreAffichage);
    const Vehicules = methods.watch('DemandeTarif.ListeVehicules');
    const VehiculesMap = Vehicules.map((vehicule, vehiculeIndex) => {
        const VehiculeListeFormules = DevisVehicules[vehiculeIndex].ListeFormules;
        if (!VehiculeListeFormules) {
            throw new Error('Formules not found');
        }
        const selectedFormule = VehiculeListeFormules.find((formule) => formule.CodeFormule === vehicule.FormuleChoisie);

        if (!selectedFormule) {
            throw new Error('Formule not found');
        }

        // Pour avoir le même ordre que les garanties dans le header
        const VehiculeListeOptions = selectedFormule.ListeGaranties.filter((garantie) => garantie.TypeGarantie === 'Option').sort(
            (a, b) => Options.findIndex((garantie) => garantie.CodeGarantie === a.CodeGarantie) - Options.findIndex((garantie) => garantie.CodeGarantie === b.CodeGarantie),
        );

        const selectedOptions = VehiculeListeOptions.filter((option) => vehicule.ListeOptionsChoisies.map((option) => option.CodeOption).includes(option.CodeGarantie));
        const totalPriceVehiculeMensuel = selectedFormule.PrimeMensuelleBase + selectedOptions.reduce((acc: number, option) => acc + option.PrimeClientMensuelle, 0);
        const totalPriceVehiculeAnnuel = selectedFormule.PrimeAnnuelleFracAnnuelBase + selectedOptions.reduce((acc: number, option) => acc + option.PrimeClient, 0);

        return {
            ...vehicule,
            VehiculeListeFormules,
            VehiculeListeOptions,
            selectedFormule,
            selectedOptions,
            totalPriceVehiculeMensuel,
            totalPriceVehiculeAnnuel,
        };
    });

    const totalAttentat = VehiculesMap.reduce((acc: number, vehicule) => {
        if (acc > 0) {
            return acc;
        }

        return acc + vehicule.selectedFormule.MontantTaxeAttentat;
    }, 0);

    const totalPrimeAnnuelle = Devis.Formule.PrimeAnnuelleFracAnnuel
    const totalPrimeMensuelle = Devis.Formule.PrimeMensuelle

    return {
        Formules,
        Options,
        Vehicules,
        VehiculesMap,
        totalAttentat,
        totalPrimeAnnuelle,
        totalPrimeMensuelle,
    };
};
